import { render, staticRenderFns } from "./TodaysAlertsWidget.vue?vue&type=template&id=853c1820&"
import script from "./TodaysAlertsWidget.vue?vue&type=script&lang=js&"
export * from "./TodaysAlertsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports